import { AppAlert } from '@components/antd';
import { Button } from 'antd';
import PreferredContactMethodModal from '../../modal/modal-preferred-contact';
import { usePreferredContact } from './hooks/use-preferred-contact';

export const PreferredContactBanner = () => {
  const {
    open,
    handleOpen,
    handleClose,
    control,
    selectedMethods,
    setValue,
    onSubmit,
    clearErrors,
    errors,
    trigger,
    handleLater,
  } = usePreferredContact();
  return (
    <>
      <AppAlert
        showIcon
        type="warning"
        message={
          <p>
            To help us assist you more quickly, add your phone & preferred support method.
            <Button className="cursor-pointer mx-2.5! text-xs! h-[25.5px]! px-5! rounded-sm!" onClick={handleLater}>
              Later
            </Button>
            <Button
              className="cursor-pointer text-xs! h-[25.5px]! px-[5px]! rounded-sm! bg-text-950! text-white!"
              onClick={handleOpen}
            >
              Add Details
            </Button>
          </p>
        }
      />
      <PreferredContactMethodModal
        open={open}
        onClose={handleClose}
        control={control}
        selectedMethods={selectedMethods}
        setValue={setValue}
        trigger={trigger}
        onSubmit={onSubmit}
        clearErrors={clearErrors}
        errors={errors}
      />
    </>
  );
};
